import { arrondiPrix } from '@/helpers/utils'

export default function afficherPrix (valeur) {
  return arrondiPrix(valeur);
}